import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CountDown } from "./countDown";
import { Price } from "../../../components/__simple/_price";
import { useUserCart } from '../../../User/hooks/useUserCart';
import config from "../../../configuration/config";

/**
 * Campaign Component
 * Displays special offers/campaigns.
 * Styled via: src/pages/parts/css/campaign.css
 */
export function Campaign({
    TotalAmountDiscount,
    TotalTime,
    startDate = new Date(),
    endDate = new Date(),
    CampaignType,
    Photo,
    Title,
    Description,
    DiscountID,
    GUID,
    toyota = true,
    to = '/parts/campaignorder',
    onChooseCompaign
}) {
    const { t: trans, i18n } = useTranslation(["eparts", "form", "info"]);
    const { changecartItem } = useUserCart();

    const lang = i18n.language || 'ar';
    const dir = lang === 'en' ? 'l' : 'r';
    const image = Photo ? Photo : "/assets/images/offers/bg.png";
    const brandClass = toyota ? "brand-toyota" : "brand-lexus";

    const handleAddToCart = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const objectCart = {
            id: DiscountID,
            name: Title,
            price: TotalAmountDiscount,
            image: Photo,
            Type: "Campaign",
        };
        changecartItem(DiscountID, null, null, 1, null, null, objectCart);
    };

    return (
        <Link to={to + "/" + GUID} className="epart-box-link">
            <div className={`epart-box ${brandClass}`}>

                {/* 1. Countdown Timer */}
                <time className="epart-box-date">
                    <CountDown
                        Total={TotalTime}
                        start={startDate.getDate()}
                        end={endDate.getDate()}
                    />
                </time>

                <div className="epart-campaign">
                    {/* 2. Campaign Type Tag */}
                    <h3 className="epart-campaign-type">
                        {CampaignType === 1 ? trans("eparts:bauget") : trans("eparts:discount")}
                    </h3>

                    {/* 3. Text Overlay */}
                    <div className={`epart-campaign-content epart-dir-${dir}`}>
                        <div className="epart-campaign-header">
                            <h2 className="epart-title">{Title}</h2>
                            <h3 className="epart-price">
                                <Price price={TotalAmountDiscount} />
                            </h3>
                        </div>
                        <div className="epart-desc">{Description}</div>
                    </div>

                    {/* 4. Background Image */}
                    <img
                        className="epart-campaign-image"
                        src={config.FilePathURL + image}
                        alt={Title}
                        loading="lazy"
                    />

                    {/* 5. Gradient Shadow */}
                    <div className="epart-overlay"></div>

                    {/* 6. Action Buttons */}
                    <div className="epart-btns">
                        <span
                            className="flexiable-btn order-now-btn"
                            onClick={(e) => {
                                e.preventDefault();
                                if (onChooseCompaign) onChooseCompaign(true, DiscountID);
                            }}
                        >
                            {trans("eparts:order-now")}
                        </span>

                        <span
                            className="flexiable-btn add-cart-btn"
                            onClick={handleAddToCart}
                        >
                            {trans("info:add_to_cart")}
                            <img src='/assets/icons/cart.svg' className="filter-white" alt="cart" />
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    );
}